(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
function setupProductRails(root=document){
 root.querySelectorAll('[data-product-rail]').forEach(section=>{
  if(section.dataset.railReady)return;
  section.dataset.railReady='true';
  const grid=section.querySelector('[data-rail-grid]');
  const prev=section.querySelector('[data-rail-prev]');
  const next=section.querySelector('[data-rail-next]');
  const controls=section.querySelector('.tb-rail-controls');
  const controller=new AbortController();
  const options={signal:controller.signal};
  const update=()=>{prev.disabled=grid.scrollLeft<=2;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;controls.hidden=grid.scrollWidth<=grid.clientWidth+2;};
  const move=direction=>{const gap=parseFloat(getComputedStyle(grid).columnGap)||0;grid.scrollBy({left:direction*(grid.clientWidth+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  prev.addEventListener('click',()=>move(-1),options);
  next.addEventListener('click',()=>move(1),options);
  grid.addEventListener('scroll',update,{...options,passive:true});
  const observer=new ResizeObserver(update);observer.observe(grid);update();
  section.railCleanup=()=>{controller.abort();observer.disconnect();delete section.dataset.railReady;};
 });
}
setupProductRails();
document.addEventListener('shopify:section:load',event=>setupProductRails(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-product-rail]').forEach(section=>section.railCleanup?.()));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
function setupNewsletterMotion(root=document){
 root.querySelectorAll('[data-news-motion]').forEach(section=>{
  if(section.newsObserver)return;
  const button=section.querySelector('[data-news-pause]');
  if(!button)return;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>section.dataset.inView=String(entry.isIntersecting)),{threshold:.15});
  observer.observe(section);section.newsObserver=observer;
  button.addEventListener('click',()=>{const paused=section.dataset.paused!=='true';section.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));});
 });
}
setupNewsletterMotion();
document.addEventListener('shopify:section:load',event=>setupNewsletterMotion(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-news-motion]').forEach(section=>section.newsObserver?.disconnect()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-cyber-collection"]) return;
  try {
    
(function(){
  function init(root){
    var start=Date.parse(root.getAttribute('data-start')),end=Date.parse(root.getAttribute('data-end'));
    var q=function(s){return root.querySelector(s)},qa=function(s){return [].slice.call(root.querySelectorAll(s))};
    // ---- cuenta regresiva real
    var D=q('[data-d]'),H=q('[data-h]'),M=q('[data-m]'),S=q('[data-s]'),label=q('[data-cmx-label]');
    function p(n){return (n<10?'0':'')+n}
    function tick(){
      var now=Date.now(),t,txt;
      if(isNaN(start)||isNaN(end))return false;
      if(now>=end){
        q('[data-cmx-clock]').hidden=true;q('[data-cmx-ticker]').hidden=true;
        q('[data-cmx-badge]').textContent='CyberMonday finalizado';
        q('[data-cmx-lead]').textContent='Gracias por participar. Revisa los productos que siguen disponibles.';
        return false;
      }
      t=end;txt='CyberMonday termina en';
      t=Math.max(0,Math.floor((t-now)/1000));
      D.textContent=p(Math.floor(t/86400));H.textContent=p(Math.floor(t%86400/3600));M.textContent=p(Math.floor(t%3600/60));S.textContent=p(t%60);
      label.textContent=txt;return true;
    }
    if(tick()){var id=setInterval(function(){if(!tick())clearInterval(id)},1000)}
    // ---- filtros, orden y vistas
    var grid=q('[data-cmx-grid]'),items=qa('.cmx__item'),st={sort:'vistos',min:0,max:0,cat:''};
    var cats={};items.forEach(function(it){var c=(it.getAttribute('data-cat')||'Otros').trim().toLowerCase();cats[c]=(cats[c]||0)+1});
    var catBox=q('[data-cmx-cats]');
    function pill(txt,val){var b=document.createElement('button');b.type='button';b.textContent=txt;b.setAttribute('data-cat',val);if(val===st.cat)b.className='on';return b}
    function drawCats(){catBox.innerHTML='';catBox.appendChild(pill('Todas ('+items.length+')',''));Object.keys(cats).sort(function(a,b){return cats[b]-cats[a]}).forEach(function(c){catBox.appendChild(pill(c.charAt(0).toUpperCase()+c.slice(1).toLowerCase()+' ('+cats[c]+')',c))})}
    drawCats();
    function norm(s){return (s||'').toLowerCase()}
    function apply(){
      var shown=0;
      items.forEach(function(it){
        var pr=+it.getAttribute('data-price'),c=it.getAttribute('data-cat')||'Otros';
        var ok=(!st.min||pr>=st.min)&&(!st.max||pr<=st.max)&&(!st.cat||norm(c)===norm(st.cat));
        it.hidden=!ok;if(ok)shown++;
        var o=+it.getAttribute('data-pos');
        if(st.sort==='dcto')o=1000-(+it.getAttribute('data-pct'))*10+o/100;
        else if(st.sort==='precio-asc')o=pr;
        else if(st.sort==='precio-desc')o=100000-pr;
        it.style.order=Math.round(o*100);
      });
      q('[data-cmx-n]').textContent=shown;
      q('[data-cmx-empty]').hidden=shown>0;
      qa('[data-cmx-clear]')[0].hidden=!(st.min||st.max||st.cat||st.sort!=='vistos');
      qa('[data-cmx-prices] button').forEach(function(b){b.className=(+b.getAttribute('data-min')===st.min&&+b.getAttribute('data-max')===st.max)?'on':''});
      qa('[data-cmx-cats] button').forEach(function(b){b.className=b.getAttribute('data-cat')===st.cat?'on':''});
    }
    q('[data-cmx-sort]').addEventListener('change',function(e){st.sort=e.target.value;apply()});
    catBox.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;st.cat=b.getAttribute('data-cat');apply()});
    q('[data-cmx-prices]').addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;st.min=+b.getAttribute('data-min');st.max=+b.getAttribute('data-max');q('[data-cmx-min]').value=st.min||'';q('[data-cmx-max]').value=st.max||'';apply()});
    function rangeIn(){st.min=+q('[data-cmx-min]').value||0;st.max=+q('[data-cmx-max]').value||0;apply()}
    q('[data-cmx-min]').addEventListener('input',rangeIn);q('[data-cmx-max]').addEventListener('input',rangeIn);
    qa('[data-cmx-clear]').forEach(function(b){b.addEventListener('click',function(){st={sort:'vistos',min:0,max:0,cat:''};q('[data-cmx-sort]').value='vistos';q('[data-cmx-min]').value='';q('[data-cmx-max]').value='';apply()})});
    function view(v){grid.setAttribute('data-view',v);qa('[data-cmx-view]').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-cmx-view')===v?'true':'false')});try{localStorage.setItem('tb-cmx-view',v)}catch(e){}}
    qa('[data-cmx-view]').forEach(function(b){b.addEventListener('click',function(){view(b.getAttribute('data-cmx-view'))})});
    try{var sv=localStorage.getItem('tb-cmx-view');if(sv==='grid'||sv==='big'||sv==='list')view(sv)}catch(e){}
    apply();
  }
  function run(){document.querySelectorAll('[data-cmx]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-cyber"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var start=Date.parse(root.getAttribute('data-start')),end=Date.parse(root.getAttribute('data-end'));
    if(isNaN(start)||isNaN(end))return;
    var label=root.querySelector('[data-tbc-label]'),digits=root.querySelector('[data-tbc-digits]');
    var D=root.querySelector('[data-d]'),H=root.querySelector('[data-h]'),M=root.querySelector('[data-m]'),S=root.querySelector('[data-s]');
    function p(n){return (n<10?'0':'')+n}
    function tick(){
      var now=Date.now(),target,txt;
      if(now>=end){root.hidden=true;return false}
      target=end;txt='CyberMonday termina en';
      var t=Math.max(0,Math.floor((target-now)/1000));
      D.textContent=p(Math.floor(t/86400));H.textContent=p(Math.floor(t%86400/3600));M.textContent=p(Math.floor(t%3600/60));S.textContent=p(t%60);
      label.textContent=txt;root.hidden=false;return true;
    }
    if(!tick())return;
    var id=setInterval(function(){if(!tick())clearInterval(id)},1000);
  }
  function run(){document.querySelectorAll('[data-tbc]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-impact-hero"] && !Shopify.designMode) return;
  try {
    
function initTecnoboxCampaign(hero){
  if(hero.dataset.ready)return;
  hero.dataset.ready='true';
  const slides=Array.from(hero.querySelectorAll('.tb-campaign__slide'));
  const controls=hero.querySelector('.tb-campaign__controls');
  if(slides.length<2){controls.hidden=true;return;}
  const abort=new AbortController(),signal=abort.signal;
  const media=window.matchMedia('(prefers-reduced-motion: reduce)');
  const dotWrap=hero.querySelector('[data-campaign-dots]');
  const pause=hero.querySelector('[data-campaign-pause]');
  const interval=Number(hero.dataset.interval)||6500;
  let index=0,paused=media.matches,timer,keyboardFocused=false,request=0,touch;
  const listen=(target,event,fn,options={})=>target.addEventListener(event,fn,{...options,signal});
  const dots=slides.map((slide,i)=>{
    const button=document.createElement('button');button.type='button';
    button.setAttribute('aria-label',hero.dataset.showLabel+' '+(i+1));
    listen(button,'click',()=>show(i));dotWrap.appendChild(button);return button;
  });
  function schedule(){clearTimeout(timer);if(!paused&&!keyboardFocused&&!document.hidden)timer=setTimeout(()=>show(index+1),interval);}
  function render(){
    slides.forEach((slide,i)=>{const on=i===index;slide.classList.toggle('is-active',on);slide.setAttribute('aria-hidden',String(!on));slide.querySelector('a').tabIndex=on?0:-1;dots[i].setAttribute('aria-current',String(on));});
    const nextImage=slides[(index+1)%slides.length].querySelector('img');if(nextImage)nextImage.loading='eager';
  }
  async function show(next){
    clearTimeout(timer);const stamp=++request;next=(next+slides.length)%slides.length;
    const img=slides[next].querySelector('img');
    if(img){img.loading='eager';try{await img.decode();}catch{}}
    if(stamp!==request||signal.aborted)return;
    index=next;render();schedule();
  }
  function updatePause(){pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?hero.dataset.resumeLabel:hero.dataset.pauseLabel);pause.firstElementChild.textContent=paused?'▷':'Ⅱ';schedule();}
  listen(pause,'click',()=>{paused=!paused;updatePause();});
  listen(hero.querySelector('[data-campaign-prev]'),'click',()=>show(index-1));
  listen(hero.querySelector('[data-campaign-next]'),'click',()=>show(index+1));
  listen(hero,'focusin',event=>{keyboardFocused=event.target.matches(':focus-visible');schedule();});
  listen(hero,'focusout',()=>{setTimeout(()=>{keyboardFocused=Boolean(hero.querySelector(':focus-visible'));schedule();},0);});
  listen(hero,'keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));}});
  listen(hero,'touchstart',event=>{touch=event.touches[0];},{passive:true});
  listen(hero,'touchend',event=>{if(!touch)return;const end=event.changedTouches[0],dx=end.clientX-touch.clientX,dy=end.clientY-touch.clientY;touch=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)show(index+(dx<0?1:-1));},{passive:true});
  listen(document,'visibilitychange',schedule);
  listen(media,'change',()=>{paused=media.matches;updatePause();});
  listen(document,'shopify:section:unload',event=>{if(event.target.contains(hero)){clearTimeout(timer);request++;abort.abort();}});
  render();updatePause();
}
document.querySelectorAll('[data-campaign]').forEach(initTecnoboxCampaign);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-campaign]').forEach(initTecnoboxCampaign));
function initShippingMessages(scope) {
  scope.querySelectorAll('[data-shipping-rotate]').forEach(button => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    const messages = Array.from(button.querySelectorAll('[data-shipping-message]'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let index = 0, timer, paused = reduced.matches;
    function schedule() {
      clearTimeout(timer);
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
      if (paused || document.hidden || button.matches(':hover, :focus-visible')) return;
      timer = setTimeout(() => {
        messages[index].hidden = true;
        index = (index + 1) % messages.length;
        messages[index].hidden = false;
        schedule();
      }, 5000);
    }
    const on = (target, name, fn) => target.addEventListener(name, fn, {signal: events.signal});
    on(button, 'click', () => { paused = !paused; schedule(); });
    on(button, 'mouseenter', schedule);
    on(button, 'mouseleave', schedule);
    on(button, 'focus', schedule);
    on(button, 'blur', schedule);
    on(document, 'visibilitychange', schedule);
    on(reduced, 'change', () => { paused = reduced.matches; schedule(); });
    on(document, 'shopify:section:unload', event => {
      if (event.target.contains(button)) { clearTimeout(timer); events.abort(); }
    });
    schedule();
  });
}
initShippingMessages(document);
document.addEventListener('shopify:section:load', event => initShippingMessages(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-product-detail"]) return;
  try {
    
function setupTecnoboxPDP(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const track=root.querySelector('[data-pdp-track]'),caption=root.querySelector('[data-pdp-caption]'),dialog=root.querySelector('dialog'),labels=JSON.parse(root.querySelector('[data-pdp-labels]').textContent);
 const allThumbs=Array.from(root.querySelectorAll('[data-pdp-image]')),allSlides=track?Array.from(track.children):[],allDots=Array.from(root.querySelectorAll('[data-pdp-dots] i'));
 let thumbs=allThumbs.filter(x=>!x.hidden),slides=allSlides.filter(x=>!x.hidden),dots=allDots.filter(x=>!x.hidden);
 let actual=-1;
 function filterColor(image){
  if(!root.hasAttribute('data-pdp-color-gallery'))return;
  const cover=allThumbs.find(b=>b.dataset.pdpImage===image),alt=cover?.dataset.pdpAlt||'';
  if(!alt.includes('P9PRO-GAL-20261016'))return;
  const color=alt.split(' — ')[2],match=' — '+color+' — ';
  const selected=allSlides.map((s,i)=>s.dataset.sAlt.includes('P9PRO-GAL-20261016')&&s.dataset.sAlt.includes(match)?i:-1).filter(i=>i>=0);
  if(selected.length!==6)return;
  allSlides.forEach((s,i)=>{const hidden=!selected.includes(i);s.hidden=hidden;if(allThumbs[i]){allThumbs[i].hidden=hidden;allThumbs[i].setAttribute('aria-pressed','false');}if(allDots[i])allDots[i].hidden=hidden;});
  slides=selected.map(i=>allSlides[i]);thumbs=selected.map(i=>allThumbs[i]);dots=selected.map(i=>allDots[i]);
  actual=-1;ir(0,false);
 }
 function marcar(i){if(i===actual||!slides[i])return;actual=i;thumbs.forEach((b,k)=>b.setAttribute('aria-pressed',String(k===i)));dots.forEach((d,k)=>d.classList.toggle('on',k===i));if(caption)caption.textContent=slides[i].dataset.sCap||'';const t=thumbs[i];if(t){const bar=t.parentElement;bar.scrollTo({left:t.offsetLeft-(bar.clientWidth-t.clientWidth)/2,behavior:'smooth'});}}
 function ir(i,suave){track.scrollTo({left:i*track.clientWidth,behavior:suave===false?'auto':'smooth'});marcar(i);}
 if(track){let raf;track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>marcar(Math.round(track.scrollLeft/(track.clientWidth||1))));},{passive:true});allThumbs.forEach(b=>b.addEventListener('click',()=>{const i=thumbs.indexOf(b);if(i>=0)ir(i);}));const ini=parseInt(track.dataset.start,10)||0;requestAnimationFrame(()=>{track.scrollTo({left:ini*track.clientWidth,behavior:'auto'});marcar(ini);});window.addEventListener('resize',()=>{if(actual>=0)track.scrollTo({left:actual*track.clientWidth,behavior:'auto'});});}
 if(dialog){allSlides.forEach(sl=>sl.addEventListener('click',e=>{e.preventDefault();const im=dialog.querySelector('img');im.src=sl.href;im.alt=sl.dataset.sAlt||'';dialog.querySelector('[data-pdp-modal-caption]').textContent=sl.dataset.sCap||'';dialog.showModal();}));dialog.querySelector('[data-pdp-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});}
 const form=root.querySelector('[data-product-form]'),select=form.querySelector('select[name=id]'),variants=JSON.parse(form.querySelector('[data-variants]').textContent);
 if(select)select.addEventListener('change',()=>{const v=variants.find(v=>String(v.id)===select.value);if(!v)return;root.querySelector('[data-pdp-offer]').hidden=!(v.compare>v.rawPrice);root.querySelector('[data-pdp-was]').textContent=v.was;root.querySelector('[data-pdp-discount]').textContent=Math.round((v.compare-v.rawPrice)*100/v.compare)+'% '+labels.discount;root.querySelector('[data-pdp-stock]').textContent=v.available?labels.available:labels.soldout;root.querySelector('[data-price-now]').textContent=v.price;filterColor(v.image);if(v.image){const b=Array.from(root.querySelectorAll('[data-pdp-image]')).find(b=>b.dataset.pdpImage===v.image);if(b)b.click();}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);});
}
document.querySelectorAll('[data-tb-pdp]').forEach(setupTecnoboxPDP);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-tb-pdp]').forEach(setupTecnoboxPDP));

  } catch(e) { console.error(e); }
})();
})();
